import type { TolgeeStaticData, TreeTranslationsData } from '@tolgee/react';

// Resolved by Vite at build time. Locale files are pulled from Tolgee by CI
// (`tolgee pull`) and gitignored except en/nb, so files absent from a local
// checkout are simply not in the map and the runtime falls back to `en`.
// Kept in its own module because `import.meta.glob` cannot be compiled by
// ts-jest — tests mock this module (see src/setupTests.ts).
const localeModules = import.meta.glob<TreeTranslationsData>('./locales/*.json', {
  import: 'default'
});

export const asyncLocaleLoaders: TolgeeStaticData = Object.fromEntries(
  Object.entries(localeModules).map(([filePath, load]) => [
    filePath.replace('./locales/', '').replace('.json', ''),
    load
  ])
);
